import React from 'react';

function RemoveValueIcon(props) {
    const {className = '', value, onClick} = props;

    if (!value) return null;

    return (
        <button type="button" className={className} onClick={onClick}>
            <span className="glyphicon glyphicon-remove-sign"></span>
        </button>
    );
}

export default RemoveValueIcon;
